import { MatDialogRef } from '@angular/material/dialog';
import { CanDeactivateGuard } from '../../../guards/can-deactive.guard';

export class BaseDialog {
  constructor(
    dialogRef: MatDialogRef<any>
  ) {
    CanDeactivateGuard.subscribeToRouteChange(() => {
      dialogRef.close();
    })
  }

}
